<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KuovEj/tc-custom/9781250123350.jpg?1736425255202" alt="This image is the cover for the book Family Favorite Casserole Recipes, RecipeLion"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Family Favorite Casserole Recipes, RecipeLion
      </h1>
      <p class="bookDescription body article font2">
        <b>First in the RecipeLion series—103 easy, accessible casserole recipes that are ideal for entertaining, everyday dinners, and even breakfast and desserts.</b><br/><br/>From Cinnamon Roll Casserole to John Wayne Cowboy Casserole, the 103 casserole dishes in this cookbook are simple and stress-free, but each is packed with flavor, making them your go-to family favorites to whip up any day of the week. In <i>103 Family Favorite Casserole Recipes</i>,<i></i>Addie Gundry shows that a dish doesn’t have to be complicated to be creative. You don’t need multiple pots and pans to find flavor. And with the proper tools, tips and techniques, anyone can cook memorable meals. She teaches you how to whip up everything from Potato Chip and Chicken Casserole to Strawberry Icebox Casserole to Skinny Cheeseburger Casserole. A casserole is something to be shared—something warm, rich, and worthy of a gathering on its own. Every recipe is paired with a beautiful finished-dish photograph that will make readers jump at the idea of casserole night.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Addie Gundry
      </h2>
      
      <p class="authorDescription body article">ADDIE GUNDRY received her masters in culinary arts at Auguste Escoffier in Avignon, France. She has worked for chefs including Daniel Boulud, Thomas Keller, and Martha Stewart on management, restaurant openings, brand development, editorial, marketing, and sales. In 2015, she won <I>Cutthroat Kitchen</I> on The Food Network. As the executive producer for RecipeLion, Addie creates culinary content for multiple web platforms and communities. She excels at making easy recipes elegant. Her books include <I>Everyday Dinner Ideas</I>, <I>Family Favorite Casserole Recipes</I>, and <I>Festive Holiday Recipes</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Griffin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?47ebfcbc